import React from 'react';
import { cn } from '../../lib/utils';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  size?: 'sm' | 'md' | 'lg' | 'xl';
  fullWidth?: boolean;
  href?: string;
}
export function Button({
  className,
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  href,
  children,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-md font-bold transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none active:scale-95 shadow-lg hover:shadow-xl uppercase tracking-wide';
  const variants = {
    primary: 'bg-[#27c227] text-white hover:bg-[#20a020] border-b-4 border-[#1b8a1b]',
    secondary: 'bg-blue-600 text-white hover:bg-blue-700 border-b-4 border-blue-800',
    outline: 'border-2 border-gray-300 bg-white hover:bg-gray-50 text-gray-700'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base md:text-lg',
    xl: 'h-16 px-10 text-lg md:text-xl py-4'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  const combinedClassName = `${baseStyles} ${variants[variant]} ${sizes[size]} ${widthClass} ${className || ''}`;
  if (href) {
    return <a href={href} className={combinedClassName} data-id="element-195">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-196">
      {children}
    </button>;
}